import React, { useRef, useEffect, useState } from 'react';

import { Box, Grid, Typography } from "@material-ui/core"

import Animation from "../../Components/Animation"
import Page from "../../Components/Page"

import LogoAnimation from "../../Components/LogoAnimation"
import PageLoading from "../../Components/PageLoading"

export default () => {
    const containerRef = useRef(null);

    const [dimensions, setDimensions] = useState({
        width: 0,
        height: 400
    });

    useEffect(() => {
        const handleGetDimensions = () => {
            if (containerRef.current) {
                return {
                    width: containerRef.current.offsetWidth,
                    height: containerRef.current.offsetHeight
                }
            } else {
                return false
            }
        }

        function handleResize() {
            if(handleGetDimensions()) {
                setDimensions(handleGetDimensions());
            }
        }

        setTimeout(() => {
            if (containerRef.current) {
                handleResize();
            }
        })

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [containerRef]);

    return (
        <Page title="Animationen">
            <Box marginBottom={4}>
                <Typography color="textSecondary" gutterBottom>Klicke in die jeweilige Animation um sie auszuführen oder zu verändern.</Typography>
            </Box>

            <Grid container spacing={4}>
                <Grid item xs={12} lg={4}>
                    <Animation title="Logo" ref={containerRef}>
                        <LogoAnimation width={dimensions.width} />
                    </Animation>
                </Grid>

                <Grid item xs={12} lg={4}>
                    <Animation title="Page Loading">
                        <PageLoading width={dimensions.width} />
                    </Animation>
                </Grid>

                <Grid item xs={12} lg={4}>
                    <Animation title="Page Transition">

                    </Animation>
                </Grid>
            </Grid>
        </Page>
    )
}